module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wt-dragoon-soft.09817042.png";